import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getDepartmentSuppliers = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/department-suppliers`);
    return response.data;
  } catch (error) {
    console.error('Error fetching department suppliers:', error.response?.data || error);
    throw error;
  }
};

export const getDepartmentSupplierById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/department-suppliers/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching department supplier:', error.response?.data || error);
    throw error;
  }
};

export const createDepartmentSupplier = async (payload) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/department-suppliers`, payload);
    return response.data;
  } catch (error) {
    console.error('Error creating department supplier:', error.response?.data || error);
    throw error;
  }
};

export const updateDepartmentSupplier = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/department-suppliers/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating department supplier:', error.response?.data || error);
    throw error;
  }
};

export const deleteDepartmentSupplier = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/department-suppliers/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting department supplier:', error.response?.data || error);
    throw error;
  }
};

export const getSupplierForDepartment = async ({ departmentId, sourceOfSupplyId }) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/department-suppliers/getSupplierForDepartment`, {
      params: { departmentId, sourceOfSupplyId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching department supplier mapping:', error.response?.data || error);
    throw error;
  }
};
